// import store from '@/store'

const state = {
  playerProps: [],
  expansionPanel: 1,
  triggerPlayerPropsReload: 0,
  loadPlayerPropsComplete: 0,
  isLoading: false,
  isPlayerPropsEmpty: false
}

const getters = {
  getPlayerProps (state) {
    return state.playerProps
  },
  getIsLoading (state) {
    return state.isLoading
  },
  getIsPlayerPropsEmpty (state) {
    return state.isPlayerPropsEmpty
  },
  getExpansionPanel (state) {
    return state.expansionPanel
  }
}

const actions = {}

const mutations = {
  setPlayerProps (state, data) {
    state.playerProps = data
  },
  setLoadPlayerPropsComplete (state) {
    state.loadPlayerPropsComplete++
  },
  setIsLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  setIsPlayerPropsEmpty (state, isPlayerPropsEmpty) {
    state.isPlayerPropsEmpty = isPlayerPropsEmpty
  },
  setExpansionPanel (state, expansionPanel) {
    state.expansionPanel = expansionPanel
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/playerProps.js